<div id="top" *ngIf="isSuperUser">

  <div><a (click)="SubmitReport(report1)">AuditAvl_ListAuditsReport</a></div>
  <div><a (click)="SubmitReport(report2)">AuditStd_ListAuditsReport</a></div>
  <div><a (click)="SubmitReport(report3)">AuditRvr_ListAuditResultsReport</a></div>
  <div><a (click)="SubmitReport(report4)">AuditRvr_ListAuditsReport</a></div>
  <div><a (click)="SubmitReport(report5)">AuditStd_SabreLikleyBadIPCReport</a></div>
  <div><a (click)="SubmitReport(report6)">AuditStd_AuditPropertyReport</a></div>
  <div><a (click)="SubmitReport(report7)">MessageLog_ListReport</a></div>
  <div><a (click)="SubmitReport(report8)">AuditStd_AuditPropertyReport</a></div>
  <div><a (click)="SubmitReport(report9)">MonthlyCounts (Jan-Dec 2020)</a></div>
  <div><a (click)="SubmitReport(report10)">Log_RecentLogReport</a></div>
  <hr>
  BAR Processor file downloads
  <div><a (click)="SubmitDownloadBARProcessorFile(0)">{{fileList[0]}}</a></div>
  <div><a (click)="SubmitDownloadBARProcessorFile(1)">{{fileList[1]}}</a></div>
  <div><a (click)="SubmitDownloadBARProcessorFile(2)">{{fileList[2]}}</a></div>
  <div><a (click)="SubmitDownloadBARProcessorFile(3)">{{fileList[3]}}</a></div>
  <div><a (click)="SubmitDownloadBARProcessorFile(4)">{{fileList[4]}}</a></div>
  <div><a (click)="SubmitDownloadBARProcessorFile(5)">{{fileList[5]}}</a></div>
  <div><a (click)="SubmitDownloadBARProcessorFile(6)">{{fileList[6]}}</a></div>
</div>
<div id="top" *ngIf="!isSuperUser">
  <div>BAR Processor file download</div>
  <div><a (click)="SubmitDownloadBARProcessorFile(0)">{{fileList[0]}}</a></div>
</div>
